var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zt-page-content"},[_c('div',{staticClass:"zt-block",staticStyle:{"margin-bottom":"0"}}),_c('div',[_c('GoodCat')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }